import { stateKey } from './actions'

export const selectAccordionPagination = (state, domain) => state[stateKey][domain]
